export enum ActivationExceptionType {
    FailedLicenseValidation = 0,
    LicenseExpired,
    LicenseAlreadyActivated,
    UserAlreadyExist,
    NotEnoughSlots,
    LoginFormatError,
}
